var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.711685,
    y: 0.711685,
    width: 25.5766,
    height: 25.5766,
    rx: 4.28832,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.951 14.6951C20.8542 15.6773 20.5722 16.6323 20.1201 17.5095C19.7726 18.1759 19.3167 18.7798 18.771 19.2964H18.7174C18.3895 19.6107 18.0268 19.8865 17.6363 20.1184C16.2826 20.897 14.7265 21.2518 13.169 21.1369C11.9009 21.0676 10.6712 20.6771 9.59524 20.0022C8.41553 19.2768 7.4575 18.2415 6.82554 17.0092C6.82218 16.9825 6.82218 16.9555 6.82554 16.9288C6.60643 16.5337 6.43545 16.1137 6.31627 15.6779C6.01802 14.6886 5.92679 13.6485 6.04824 12.6224C6.14634 11.7661 6.38797 10.9324 6.76299 10.1564C6.76299 10.1564 6.763 10.0939 6.82554 10.076L6.90595 10.1296L6.82554 10.076C7.00685 9.68008 7.23159 9.30551 7.49563 8.95921C8.36493 7.7842 9.55099 6.88115 10.9149 6.35583C12.2789 5.8305 13.7643 5.70463 15.1972 5.99294C16.5092 6.25549 17.7239 6.87364 18.7085 7.77984C18.7799 7.84239 18.771 7.87812 18.7085 7.94066L16.716 9.92412C16.6535 9.9956 16.6178 9.9956 16.5463 9.92412C16.123 9.53252 15.6214 9.23525 15.0746 9.05196C14.5278 8.86868 13.9484 8.80357 13.3746 8.86091C12.4718 8.91393 11.6057 9.237 10.8888 9.78823C10.1719 10.3395 9.6372 11.0934 9.35402 11.9523V12.0059C9.26335 12.3163 9.19467 12.6328 9.14852 12.9529C9.07524 13.5952 9.13299 14.2456 9.31828 14.8649C9.32337 14.9124 9.32337 14.9603 9.31828 15.0079C9.54074 15.6522 9.90044 16.2405 10.3725 16.7322C11.125 17.5055 12.1193 17.9981 13.1904 18.1281C14.2615 18.2581 15.3448 18.0178 16.2604 17.447H16.3229C16.5953 17.2431 16.844 17.0093 17.0645 16.7501C17.4375 16.3019 17.6925 15.7674 17.8061 15.1955C17.8061 15.0883 17.806 15.0793 17.7078 15.0793H13.7766C13.6783 15.0793 13.6515 15.0793 13.6515 14.9632V12.2471C13.6515 12.1578 13.6515 12.1309 13.7587 12.1309H20.7634C20.8438 12.1309 20.8706 12.1309 20.8795 12.2471C21.0169 13.0558 21.0409 13.8798 20.951 14.6951Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711685,
    y: 0.711685,
    width: 25.5766,
    height: 25.5766,
    rx: 4.28832,
    stroke: "white",
    strokeWidth: 0.57663
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9a67079352b2de9e598cf8ced7ca2992.svg";
export { ForwardRef as ReactComponent };